import { useMutation, useQuery } from "@tanstack/react-query"
import { isLogin } from "../../../../../utils";
import { createCommunityPolicyByCommunityPolicyCreateWebRequest, getBasicMemberByToken, getCommunityPolicyIsCommunityPolicyChecked } from "../../../../../service";

const useGetBasicMemberByToken = () => {
    const isToken = isLogin()
    const query = useQuery({
        queryKey: ['getBasicMemberByToken'],
        queryFn: getBasicMemberByToken,
        enabled: !!isToken,
        select: res => res.data
    })

    return query;
}
const useGetCommunityPolicyIsCommunityPolicyChecked = () => {
    const basicMemberQuery = useGetBasicMemberByToken();

    const query = useQuery({
        queryKey: ['getCommunityPolicyIsCommunityPolicyChecked', basicMemberQuery.data?.id],
        queryFn: getCommunityPolicyIsCommunityPolicyChecked,
        select: res => res.data
    })

    return query;
}

const useCreateCommunityPolicyByCommunityPolicyCreateWebRequest = () => {
    const mutation = useMutation({
        mutationFn: createCommunityPolicyByCommunityPolicyCreateWebRequest
    })

    return mutation;
}

export { useGetCommunityPolicyIsCommunityPolicyChecked, useCreateCommunityPolicyByCommunityPolicyCreateWebRequest }